import React, { useState, useEffect } from "react";
import axios from "axios";
// import moment from 'moment-timezone';

import Calendar from "@toast-ui/react-calendar";
import "tui-calendar/dist/tui-calendar.css";
import ReactLoading from 'react-loading';

// If you use the default popups, use this.
import "tui-date-picker/dist/tui-date-picker.css";
import "tui-time-picker/dist/tui-time-picker.css";

import SideBar from "../layout/sideBar";
import Header from "../layout/header";
import myTheme from "./calendarTheme";
import * as config from '../../config';

export default function CalendarComp(props) {
  // State 생성
  const [inputs, setInputs] = useState({
    today: new Date(),
    schedule: [],
    refresh: false,
  });
  
  const calendarRef = React.createRef();
  const loadingRef = React.useRef();
  const scheduleArr = [];

  // 최초 세팅
  useEffect(() => {
    // getList();
    
  }, []);
  
  // 날짜 변경 콜백
  useEffect(() => {
    
    const calendarInstance = calendarRef.current.getInstance();
    calendarInstance.setDate(inputs.today);

    axios
    .get(config.API_URL + "/reserve")
    .then((response) => {
      const data = response.data.reserves;
      const keys = Object.keys(data);
      
      if ( keys.length > 0 ){
        keys.forEach(key => {
          const val = data[key];
          
          scheduleArr.push({
            id: val.reserve_id,

            calendarId: val.campus_id_code,

            title: val.campus_content,
            userName: val.reserve_user_name,
            campusId: val.campus_id_code,
            category: "time",
            start: new Date(val.campus_start_time).toString(),
            end: new Date(val.campus_end_time).toString(),
          })
        });
        
        scrollDown();

        try { // Unhandled Rejection (TypeError): Cannot read properties of null (reading 'createSchedules') 에러 예외처리
          calendarInstance.createSchedules(scheduleArr);
        } catch(error) {

        }
      }
    });
  }, [inputs.today, inputs.refresh]);

  const getDate = (unit, date, num, symbol) => {
    let todayDate = new Date(date);

    if (symbol === "-") {
      num = -num;
    }

    switch (unit) {
      case "date":
        todayDate.setDate(todayDate.getDate() + num);
        break;

      case "hours":
        todayDate.setHours(todayDate.getHours() + num);
        break;

      case "minutes":
        todayDate.setMinutes(todayDate.getMinutes() + num);
        break;
    }

    return todayDate;
  };

  const openCreationPopup = () => {

    const calendarInstance = calendarRef.current.getInstance();
    // const today = new Date().getFullYear() + "-" + (new Date().getMonth()+1) + "-" + new Date().getDate();

    calendarInstance.openCreationPopup([]);

  }

  const changeToday = (date) => {
    setInputs({
      ...inputs,
      today: date
    })
  }

  const goToday = () => {
    const calendarInstance = calendarRef.current.getInstance();
    calendarInstance.today();
    setInputs({
      ...inputs,
      today: new Date()
    })
  };

  const goNextWeek = () => {
    const calendarInstance = calendarRef.current.getInstance();
    calendarInstance.next();
    setInputs({
      ...inputs,
      today: getDate('date', inputs.today, 7, '+')
    })
  };

  const goPrevWeek = () => {
    const calendarInstance = calendarRef.current.getInstance();
    calendarInstance.prev();
    setInputs({
      ...inputs,
      today: getDate('date', inputs.today, 7, '-')
    })
  };

  const showLoading = () => {
    loadingRef.current.style.display = "flex";
  }

  const hideLoading = () => {
    loadingRef.current.style.display = "none";
  }

  const scrollDown = () => {
    if ( document.querySelector(".tui-full-calendar-timegrid-container") ) {
      document.querySelector(".tui-full-calendar-timegrid-container").scrollTop = 100000;
    }
  }
  scrollDown();

  const createSchedules = (event) => {
    const calendarInstance = calendarRef.current.getInstance();
    
    const formData = new FormData();
    formData.append("campusStartTime", getTimeStamp(event.start));
    formData.append("campusEndTime", getTimeStamp(event.end));
    formData.append("campusIdCode", event.campusId);
    formData.append("reserveUserName", event.userName);
    formData.append("campusContent", event.title);

    showLoading();
    axios
      .post(config.API_URL + "/reserve", formData)
      .then((response) => {
        if ( response.data.message === "Success" ){
          let res = response.data;
          var schedule = {
            id: res.reserveId,
            title: res.campusContent,
            userName: res.reserveUserName,
            campusId: res.campusIdCode,
            category: "time",
            start: new Date(res.campusStartTime).toString(),
            end: new Date(res.campusEndTime).toString(),
          };
          
          calendarInstance.createSchedules([schedule]);
          refresh();
          alert("예약이 완료되었습니다.");
        }
      })
      .catch((error) => {
        alert("선택한 시간에 이미 예약이 있습니다.\n다른 시간을 선택해주세요.");
      }).finally(()=>{
        hideLoading();
      })
      
  };

  function fillZeros(n, digits) {  
      var zero = '';  
      n = n.toString();  

      if (n.length < digits) {  
          for (var i = 0; i < digits - n.length; i++)  
              zero += '0';  
      }  
      return zero + n;  
  }  
    
  function getTimeStamp(date) {  
      var d = new Date(date);  

      var s = fillZeros(d.getFullYear(), 4) + '-' +  
              fillZeros(d.getMonth() + 1, 2) + '-' +  
              fillZeros(d.getDate(), 2) + ' ' +  
        
              fillZeros(d.getHours(), 2) + ':' +  
              fillZeros(d.getMinutes(), 2) + ':' +  
              fillZeros(d.getSeconds(), 2);  

      return s;  
  }  


  const updateSchedule = (event) => {
    const calendarInstance = calendarRef.current.getInstance();
    const campusStartTime = event.changes && event.changes.start ? event.changes.start : event.schedule.start;
    const campusEndTime = event.changes && event.changes.end ? event.changes.end : event.schedule.end;
    const campusIdCode = event.changes && event.changes.campusId ? event.changes.campusId : event.schedule.campusId;

    const formData = new FormData();
    // formData.append("reserveId", event.schedule.id);
    formData.append("campusStartTime", getTimeStamp(campusStartTime));
    formData.append("campusEndTime", getTimeStamp(campusEndTime));
    formData.append("campusIdCode", event.changes && event.changes.campusId ? event.changes.campusId : event.schedule.campusId);
    formData.append("reserveUserName", event.changes && event.changes.userName ? event.changes.userName : event.schedule.userName);
    formData.append("campusContent",event.changes &&  event.changes.title ? event.changes.title : event.schedule.title);

    showLoading();
    axios
      .put(config.API_URL + "/reserve/" + event.schedule.id , formData)
      .then((response) => {
        /* eslint no-restricted-globals: ["off"] */
        if(getTimeStamp(event.changes.end)===getTimeStamp(event.schedule.end)){
          alert("계정변경은 상세팝업의 예약수정을 이용해주세요.");
          return;
        }else{
          if(confirm("예약을 수정하시겠습니까?")) {
            if (response.data.message === "Success"){
              calendarInstance.updateSchedule(event.schedule.id, event.schedule.calendarId, event.changes);
              refresh();
              alert("예약수정이 완료되었습니다.");
            }
            // return;
          }
        }
      })
      .catch((error) => {
        alert("선택한 시간에 이미 예약이 있습니다.\n예약한 수강자와 협의해주세요.");
      }).finally(()=>{
        hideLoading();
      });
  };

  const deleteSchedule = (event) => {
    if ( !window.confirm("예약취소 하시면 복구가 불가합니다.\n그래도 예약을 취소하시겠습니까?") ){
      return;
    }

    const calendarInstance = calendarRef.current.getInstance();

    showLoading();
    axios
      .delete(config.API_URL + "/reserve/"+ event.schedule.id)
      .then((response) => {
        calendarInstance.deleteSchedule(event.schedule.id, event.schedule.calendarId);
        alert("예약이 취소되었습니다.");
      })
      .catch((error) => {
        
      })
      .finally(()=>{
        hideLoading();
      })
      ;
      
  };

  const refresh = () => {
    setInputs({...inputs, refresh: !inputs.refresh});
  }

  const loading = () => {
      return (
        <div className="loading" style={{display:"none"}} ref={loadingRef}>
          <ReactLoading type={"spokes"} color="#222" />
        </div>
      )
  }
  
  const MyComponent = () => (
    <Calendar
      ref={calendarRef}
      usageStatistics={false}
      theme={myTheme}
      height="1325px"
      calendars={[
        {
          id: "None",
          name: "계정선택",
          bgColor: "#555",
          borderColor: "#555",
          dragBgColor: '#555',
        },
        {
          id: "0",
          name: "0",
          bgColor: "#42a5f5",
          borderColor: "#42a5f5",
          dragBgColor: '#42a5f5',
        },
        {
          id: "1",
          name: "1",
          bgColor: "#ab47bc",
          borderColor: "#ab47bc",
          dragBgColor: '#ab47bc',
        },
      ]}
      taskView={false}
      disableDblClick={true}
      disableClick={false}
      isReadOnly={false}
      month={{
        startDayOfWeek: 0,
      }}
      schedules={inputs.schedule}
      timezones={[
        {
          displayLabel: 'GMT+09:00',
          tooltip: 'Seoul'
        }
      ]}
      useDetailPopup={true}
      useCreationPopup={true}
      week={{
        showTimezoneCollapseButton: false,
        timezonesCollapsed: false,
        hourEnd:24,
        narrowWeekend: true
      }}
      onAfterRenderSchedule={scrollDown}
      onBeforeCreateSchedule={createSchedules}
      onBeforeUpdateSchedule={updateSchedule}
      onBeforeDeleteSchedule={deleteSchedule}
    />
  );

  return (
    <div>
      <Header openCreationPopup={openCreationPopup}/>
      <div>
        <SideBar today={inputs.today} onChangeDate={changeToday} />
        <div className="mainComponent">
          <div className="weekNavigator">
            <div className="text-center weekNavigator-month">
              <span className="weekNavigatorText">{inputs.today.getFullYear()}년 {inputs.today.getMonth()+1}월</span>
              <img src="images/btn_nextweek@3x.png" className="btn-nextWeek pointer" onClick={goNextWeek}  />
              <img src="images/btn_preweek@3x.png" className="btn-prevWeek pointer" onClick={goPrevWeek} />
              <img src="images/btn_today@3x.png" className="btn-today pointer" onClick={goToday} />
            </div>
          </div>
          <MyComponent />
        </div>
      </div>
      {loading()}
    </div>
  );
} 